import TermsConditionsModal from './TermsConditionsModal';

export default TermsConditionsModal;
